import { Controller } from "@hotwired/stimulus"

// The membership flow's create-account details (TMS-1656). Continue waits until the salutation and
// name are filled and the address is whole — the shared address-entry controller on the same form
// says when it is, through `address-entry:change`. The server checks all of this again
// (Memberships::AccountDetails).
export default class extends Controller {
  static targets = ["required", "submit"]

  connect() {
    this.addressReady = this.addressReady ?? false
    this.refresh()
  }

  addressChanged(event) {
    this.addressReady = Boolean(event.detail?.complete) && !event.detail?.pending
    this.refresh()
  }

  refresh() {
    this.submitTarget.disabled = this.requiredTargets.some((input) => input.value.trim() === "") || !this.addressReady
  }
}
